import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PublisherUser } from '../../../../../models/publisher-user';
import { SystemMessage } from '../../../../../models/system-message';
import { MessageService } from '../../../../../_services/message.service';
import { DataService } from '../../../../../_services/data.service';
import { ValidationService } from '../../../../../_services/validation.service';

@Component({
    selector: 'app-system-message',
    templateUrl: './system-message.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SystemMessageComponent implements OnInit {
    systemMessage: SystemMessage = new SystemMessage();
    validator;

    constructor(
        private messageService: MessageService,
        private dataService: DataService,
        private validationService: ValidationService
    ) { }

    ngOnInit(): void {
        this.systemMessage.publisherId = this.dataService.publisherId;
    }

    validate(event) {
        let self = this;
        let result = this.validationService.validateWithValidator(event, {
            rules: {
                message: {
                    required: true
                }
            }
        });
        this.validator = result.validator;
        return result.isValid;
    }

    sendMessage() {
        let self = this;
        self.messageService.sendMessage(this.systemMessage);
        self.systemMessage.message = '';
        setTimeout(function() {
            self.validator.resetForm();
        }, 10);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/system-message/system-message.component.ts